import getHostVariables from './getHostVariables';
import {ANCESTOR_ROOT_NODE} from '../symbols';

export default function getAncestorNode(host) {
	return getHostVariables(host)[ANCESTOR_ROOT_NODE];
}
